export default "__VITE_ASSET__D_ZN2bW1__"